import React from 'react';
import { BasketPanel, BasketPanelProps } from './BasketPanel';
import { ButtonVariant } from '@components/material-ui';
import styled from '@emotion/styled';
import { ZIndex } from '@styles/z-index';
import { breakpoints, mq } from '@styles/breakpoints';
import { TestId } from '@components/test-ids';
import { ThemeProps } from '@theme/base';

export interface BasketPanelSlideContainerProps extends BasketPanelProps {
  fixed?: boolean;
  checkout?: boolean;
  top?: number;
  buttonVariant?: ButtonVariant;
  offset?: number;
  isLoading?: boolean;
  isGhosting?: boolean;
  buttonId?: string;
}

export const basketPanelId = 'basketPanel';

interface PanelProps extends ThemeProps {
  fixed?: boolean;
  top?: number;
  offset?: number;
  inline?: boolean;
}
export const Panel: any = styled.div(({ theme, fixed, top, offset, inline }: PanelProps) => ({
  position: inline ? 'static' : 'fixed',
  zIndex: ZIndex.PRODUCT_PRICE,
  bottom: 0,
  width: '100%',
  [mq.medium]: {
    position: fixed ? 'relative' : 'sticky',
    top: top || top === 0 ? top : theme.custom.spacing.large,
    bottom: 'auto',
    marginTop: offset || 0
  },
  [mq.ie(breakpoints.medium)]: {
    position: 'relative',
    top: theme.custom.spacing.large
  }
}));

export const BasketPanelContainer = (props: BasketPanelSlideContainerProps) => (
  <Panel id={basketPanelId} data-testid={TestId.basketPanel} fixed={props.fixed} top={props.top} offset={props.offset}>
    <BasketPanel {...props} />
  </Panel>
);
